import { A11yModule } from '@angular/cdk/a11y';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'nf-root',
  // A11yModule is imported here (unused in the template) purely to force its NgModuleRef
  // to be constructed during the app's very first, properly-zoned bootstrap render. Some
  // sk-*/tb-* components pull in CDK Overlay (which imports A11yModule) lazily, the first
  // time an overlay-based UI (dropdown, tooltip, dialog) renders; if that first render is
  // triggered from a callback outside Angular's zone/injection context, constructing
  // A11yModule there for the first time throws NG0203 and blanks the whole app. Forcing
  // construction here means later triggers just reuse the already-built singleton.
  imports: [RouterOutlet, A11yModule],
  template: '<router-outlet></router-outlet>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {}
